/** «Para usar esto, crea tu contraseña» — aparece cuando el backend responde 403 PASSWORD_REQUIRED a una acción. */
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { KeyRound } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { tr } from '@/contexts/LanguageContext';

export const PasswordRequiredDialog = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    const on = () => setOpen(true);
    window.addEventListener('lineage:password-required', on);
    return () => window.removeEventListener('lineage:password-required', on);
  }, []);
  const go = () => {
    setOpen(false);
    navigate(`/crear-contrasena?next=${encodeURIComponent(location.pathname + location.search)}`);
  };
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-w-sm" data-testid="password-required-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><KeyRound className="w-5 h-5 text-primary" />{tr("Para usar esto, crea tu contraseña")}</DialogTitle>
          <DialogDescription>{tr("Tu cuenta se creó al reservar y aún no tiene contraseña. Créala en un minuto y volverás a lo que estabas haciendo.")}</DialogDescription>
        </DialogHeader>
        <div className="flex gap-2 justify-end">
          <Button variant="ghost" onClick={() => setOpen(false)} data-testid="password-required-later-btn">{tr("Ahora no")}</Button>
          <Button onClick={go} className="rounded-full" data-testid="password-required-create-btn">{tr("Crear contraseña")}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
